import { catchError, debounce, pipe } from 'overmind';

import { type Context } from '@/overmind';
import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

export const setSelectedFeature = pipe(
  debounce(150),
  (context: Context, newSelectedFeature: FeatureWithIDs) => {
    const newSelectedFeatureCopy = window.structuredClone(newSelectedFeature);
    if (context.state.selectedFeature.current !== newSelectedFeatureCopy) {
      context.state.selectedFeature.current = newSelectedFeatureCopy;
      context.state.map.view?.highlight(newSelectedFeatureCopy);
    }
  }
);

export const unselectFeature = pipe((context: Context) => {
  if (context.state.selectedFeature.current !== undefined) {
    context.state.selectedFeature.current = undefined;
    context.state.map.view?.stopHighlighting()
  }
});

export const setCalculationSets = pipe(
  async ({ effects, state }: Context) => {
    const selectedFeature = state.selectedFeature;
    if (selectedFeature !== null) {
      const id = selectedFeature.current?.gc.globalId;
      const currentTenant = state.tenants.currentTenant;
      if (currentTenant.type === 'SELECTED_TENANT' && id !== undefined) {
        state.calculation.calculationSets.send('TRIGGER_LOADING');
        const calculationSets =
          await effects.api.orchestrator.getCalculationSetsForRelatedObject(
            currentTenant.context.tenantId,
            id,
            state.auth.matches('AUTHENTICATED')?.arcgisToken
          );
        state.calculation.calculationSets.send(
          'FETCH_SUCCESS',
          calculationSets
        );
      }
    }
  },
  catchError((context: Context, error: Error) => {
    context.state.calculation.calculationSets.send(
      'FETCH_ERROR',
      error.message
    );
  })
);
